import { createMuiTheme } from '@material-ui/core/styles';
import { blue, cyan, yellow } from '@material-ui/core/colors';

const theme = createMuiTheme({
  palette: {
    primary: {
      // light: '#757ce8',
      main: '#000000',
      // dark: '#002884',
      contrastText: '#fff',
    },
    secondary: {
      // light: '#ff7961',
      main: '#e65100',
      // dark: '#ba000d',
      contrastText: '#000',
    },
  },
});

export default theme;